import Vue from "Vue";
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class InputNumber extends Vue {
    @Prop({default: ""})
    public label;

    @Prop({default: 0})
    private vmodel;

    @Prop({default: 10})
    private length;

    @Prop({default: false})
    private disabled;

    @Prop({default: true})
    private show;

    @Prop({default: false})
    private required;

    @Prop({default: false})
    private error;

    @Prop({default: true})
    private decimal;

    @Prop({default: false})
    private right;

    @Prop({default: ""})
    private symbol;

    public value;

    constructor() {
        super();
        this.value = (this.decimal) ? "0,00" : "0";

        if(this.symbol != "") {
            this.value += " " + this.symbol;
        }
    }

    @Watch('vmodel', {immediate: true})
    private setValue(): void {
        this.value = (this.decimal) ? this.formatDecimal(this.vmodel) :
                                      this.formatInteger(this.vmodel);

        if(this.symbol != "") {
            this.value += " " + this.symbol;
        }
    }

    private isTextSelected(e): boolean {
        return e.target.selectionStart == 0 && e.target.selectionEnd == e.target.value.length;
    }

    public keydown(e): void {
        let regexp = (this.decimal) ? new RegExp("^([0-9]{1,"+ this.length +"})([,.][0-9]{0,2})?$") :
                                      new RegExp("^[0-9]{1,"+ this.length +"}$");
        let testString = (this.isTextSelected(e)) ? e.key :
                                                    e.target.value.substring(0, e.target.selectionStart) + e.key + e.target.value.substring(e.target.selectionStart);

        if (e.key != "Backspace" &&
            e.key != "ArrowLeft" &&
            e.key != "ArrowRight" &&
            e.key != "ArrowUp" &&
            e.key != "ArrowDown" &&
            e.key != "Comma" &&
            e.key != "Tab") {

            if(parseInt(testString) != null) {
                if (!regexp.test(testString)) {
                    e.preventDefault();
                }
            }
        }
    }

    public focus(e): void {
        if(this.symbol != "") {
            e.target.value = e.target.value.replace(this.symbol, "");
        }

        if(this.decimal) {
            e.target.value = e.target.value.replace(",00", "");
        }

        e.target.value = e.target.value.replace(/ /g,"");
        e.target.select();
        this.$emit('focus');
    }

    public blur(e): void {
        if(this.decimal) {
            this.vmodel = (e.target.value != "") ? Number(e.target.value.replace(",", ".")) : 0;
            e.target.value = this.formatDecimal(e.target.value);
        } else {
            this.vmodel = (e.target.value != "") ? e.target.value : 0;
            e.target.value = this.formatInteger(e.target.value);
        }

        if(this.symbol != "") {
            e.target.value += " " + this.symbol;
        }

        this.$emit('update:vmodel', this.vmodel);
    }

    public paste(e): void {
        e.preventDefault();
    }

    private formatDecimal(value: string | number): string {
        value = value.toString().replace(",", ".").replace(".00", "").replace(/ /g,"");
        value = Number(value).toFixed(2);
        value = value.replace(".", ",");
        return this.numberWithSpaces(value);
    }

    private formatInteger(value: string | number): string {
        value = value.toString().replace(/ /g,"");
        return this.numberWithSpaces(value);
    }

    private numberWithSpaces(x: string): string {
        let parts = x.split(",");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        return parts.join(",");
    }
}



// WEBPACK FOOTER //
// ./src/shared/components/InputNumber/InputNumber.ts